import React, { Component } from 'react';
import { connect } from 'react-redux'
import styled from 'styled-components';
import Fonts from '../Styles/Fonts';
import Colors from '../Styles/Colors';
import Button from '../Components/Button';
import HomePageWrapper from '../Components/HomePageWrapper';

const Logo = styled.img`
  max-width: 82%;
`;
const Title = styled.h1`
  ${Fonts.decotura.medium}
  color: ${Colors.white};
  font-size: 48px;
  margin: 21px 0 0 0;
  text-transform: uppercase;
`;
const BodyText = styled.p`
  ${Fonts.spectral.regular}
  color: ${Colors.white};
  font-size: 14px;
  line-height: 19px;
  padding: 0 35px;
`;

class HomePage extends Component {
  componentDidMount = () => {
  };

  render() {
    return (
      <HomePageWrapper>
          <Logo src="/_assets/img/passport-app/acic-lks-logo-main.png" alt="Atlantic Casualty | The Lock &amp; Key Speakeasy" />
          <Title>{ this.props.content.title }</Title>
          <BodyText>{ this.props.content.content }</BodyText>
          <Button to="/event-info">Event Info</Button>
      </HomePageWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      content: state.content.homepageContent
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);